<template>
  <div v-if="permission.user_edit" @click="goToDetail()">
    <u class="detail">ดูรายละเอียด</u>
  </div>
  <div v-else>
    <u class="no-detail">ดูรายละเอียด</u>
  </div>
</template>

<script>
export default {
  mounted() {
    // console.log("params", this.params);
  },
  computed: {
    permission() {
      return this.$store.getters.getPermission;
    },
  },
  methods: {
    goToDetail() {
      console.log(this.params.data.SeeDetail);
      this.$router.push(`/createmember/${this.params.data.SeeDetail}`);
    },
  },
};
</script>

<style scoped>
.detail {
  color: #03a9f3;
  cursor: pointer;
}

.no-detail {
  color: #7f7d9c;
  cursor: not-allowed;
}
</style>
